import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelSeatmapResultRequest,
  failSeatmapResult,
  setSeatmapResult,
  setSeatmapResultFromApi,
  updateSeatmapResult,
  updateSeatmapResultFromApi,
} from './seatmap-result.actions';

/**
 * Service to handle async SeatmapResult actions
 */
@Injectable()
export class SeatmapResultEffect {
  /**
   * Set the state with the reply content, dispatch failSeatmapResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setSeatmapResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setSeatmapResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failSeatmapResult({ error, requestId: action.requestId })),
        cancelSeatmapResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failSeatmapResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateSeatmapResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateSeatmapResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failSeatmapResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
